module.exports = __webpack_public_path__ + "img/globeinsure.ec17aaea.png";